import * as mutation from "./mutation-types";
import { tableHelper } from "@/helpers/table.helper";
import { getBlankRecord } from "./helpers";
import { getBlankNextPreviousInfo } from "@/store/helpers";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      data: [],
      paging: tableHelper.getDefaultPaging("Type"),
      loading: false,
      loaded: false
    },
    view: {
      data: getBlankRecord(),
      next: getBlankNextPreviousInfo(),
      previous: getBlankNextPreviousInfo(),
      breadcrumbs: [{ text: "..." }],
      loading: false,
      loaded: false,
      scheduledJobId: null
    },
    edit: {
      data: getBlankRecord(),
      isNew: true,
      loading: false,
      saving: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "edit"
      }
    },
    delete: {
      id: null,
      saving: false
    },
    run: {
      id: null,
      processing: false
    },
    runOverdue: {
      processing: false
    }
  };
}

export function getUnloadedState() {
  return {
    listing: {
      loaded: false
    },
    view: {
      loaded: false
    }
  };
}
